import { createRoute, Outlet, redirect } from "@tanstack/react-router";
import { appLayoutRoute } from "@/routes/layout-routes";
import { ImportUploadScreen } from "@/app/Import/Screens/ImportUploadScreen";
import { ImportSelectSupplierScreen } from "@/app/Import/Screens/ImportSelectSupplierScreen";
import { ImportSpreadsheetScreen } from "@/app/Import/Screens/ImportSpreadsheetScreen";
import { fetchQuery } from "@/lib/GraphQLCodegen/fetcher";
import { supplierRecordQuery } from "@/app/Suppliers/GraphQL/supplierRecordQuery";
import { supplierParamToId } from "@/app/Suppliers/Utils/globalSupplier";

export const importParentRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/import",
  component: Outlet,
  head: () => ({
    meta: [
      {
        title: "Import - Imoova Admin",
      },
    ],
  }),
});

export const importSelectSupplierRoute = createRoute({
  getParentRoute: () => importParentRoute,
  beforeLoad: async ({ params }) => {
    const supplierId = supplierParamToId(params.supplierId);
    if (supplierId) {
      throw redirect({
        from: "/$tenant/$orgId/supplier/{-$supplierId}",
        to: "/$tenant/$orgId/supplier/{-$supplierId}/import/$importSupplierId",
        params: (prev) => ({
          ...prev,
          importSupplierId: supplierId,
        }),
      });
    }
  },
  path: "/",
  component: ImportSelectSupplierScreen,
  head: () => ({
    meta: [
      {
        title: "Select Supplier - Imoova Admin",
      },
    ],
  }),
});

export const importSupplierRoute = createRoute({
  getParentRoute: () => importParentRoute,
  path: "/$importSupplierId",
  component: Outlet,
  loader: ({ params }) => {
    return fetchQuery(
      supplierRecordQuery,
      {
        id: params.importSupplierId,
      },
      params.orgId,
    );
  },
  head: ({ params }) => ({
    meta: [
      {
        title: `Import ${params.importSupplierId} - Imoova Admin`,
      },
    ],
  }),
});

export const importUploadRoute = createRoute({
  getParentRoute: () => importSupplierRoute,
  path: "/",
  component: ImportUploadScreen,
  head: ({ params }) => ({
    meta: [
      {
        title: `Upload Import ${params.importSupplierId} - Imoova Admin`,
      },
    ],
  }),
});

export const importSpreadsheetRoute = createRoute({
  getParentRoute: () => importSupplierRoute,
  path: "/spreadsheet",
  component: ImportSpreadsheetScreen,
});
